import { render, staticRenderFns } from "./VoucherForm.vue?vue&type=template&id=fa507894&scoped=true&"
import script from "./VoucherForm.vue?vue&type=script&lang=js&"
export * from "./VoucherForm.vue?vue&type=script&lang=js&"
import style0 from "./VoucherForm.vue?vue&type=style&index=0&id=fa507894&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa507894",
  null
  
)

export default component.exports